/** 捕风引擎防护等级 */
export enum EngineLevel {
  /** 最高 */
  highest = 1,
  /** 严格 */
  strict = 2,
  /** 智能 */
  smart = 3,
  /** 普通 */
  normal = 4
}
